import React, { useRef, useEffect } from "react";
import styled from "styled-components";

const StyledCanvas = styled.canvas`
  transition: transform 0.2s ease-in-out;

  transform: rotate(${(props) => props.rotate}deg);
`;

const ZoomArea = ({ src, sliderValue, rotate, canvasWidth, canvasHeight }) => {
  const canvasRef = useRef();

  useEffect(() => {
    let img = new Image();
    let canvas = canvasRef.current;

    var ctx = canvas.getContext("2d");

    function clear() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    clear();

    let width,
      height,
      raf,
      dragged = false,
      cordinate = { x: 0, y: 0 },
      dragStartPosition = { x: 0, y: 0 },
      currentTransformedCursor,
      scale = 1 + sliderValue / 100;

    img.onload = () => {
      width = img.width * scale;
      height = img.height * scale;

      const ratio = img.height / img.width;

      if (img.width > canvas.width) {
        width = canvas.width;
        height = ratio * width;
      }

      cordinate = {
        x: (canvas.width - width) / 2,
        y: (canvas.height - height) / 2,
      };

      ctx.drawImage(img, cordinate.x, cordinate.y, width, height);
    };

    const drawImage = () => {
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.restore();

      ctx.drawImage(img, cordinate.x, cordinate.y, width, height);
    };

    function getTransformedPoint(x, y) {
      const transform = ctx.getTransform();
      const transformedX = x - transform.e;
      const transformedY = y - transform.f;
      return { x: transformedX, y: transformedY };
    }

    canvas.addEventListener(
      "mousedown",
      function (evt) {
        const touchobj = evt.changedTouches && evt.changedTouches[0];
        if (!touchobj) {
          dragged = true;
          dragStartPosition = getTransformedPoint(evt.offsetX, evt.offsetY);
        }
      },
      false,
    );

    canvas.addEventListener(
      "touchstart",
      function (evt) {
        const touchobj = evt.changedTouches && evt.changedTouches[0];
        dragged = true;
        dragStartPosition = { x: touchobj.clientX, y: touchobj.clientY };
      },
      false,
    );

    canvas.addEventListener(
      "touchmove",
      function (evt) {
        const touchobj = evt.changedTouches && evt.changedTouches[0];

        currentTransformedCursor = getTransformedPoint(
          touchobj.clientX,
          touchobj.clientY,
        );

        ctx.translate(
          currentTransformedCursor.x - dragStartPosition.x,
          currentTransformedCursor.y - dragStartPosition.y,
        );
        drawImage();
      },
      false,
    );

    canvas.addEventListener(
      "mousemove",
      function (evt) {
        if (dragged) {
          document.body.style.cursor = "pointer";
          currentTransformedCursor = getTransformedPoint(
            evt.offsetX,
            evt.offsetY,
          );

          ctx.translate(
            currentTransformedCursor.x / scale - dragStartPosition.x,
            currentTransformedCursor.y / scale - dragStartPosition.y,
          );
          drawImage();
        }
      },
      false,
    );

    document.addEventListener(
      "mouseup",
      function () {
        dragged = false;
        document.body.style.cursor = "default";
      },
      false,
    );

    img.src = src;

    return () => window.cancelAnimationFrame(raf);
  }, [src, sliderValue]);

  return (
    <StyledCanvas
      height={canvasHeight}
      width={canvasWidth}
      rotate={rotate}
      ref={canvasRef}
    ></StyledCanvas>
  );
};

export default ZoomArea;
